import React from 'react'
//@ts-ignore
import styles from './chips.module.scss'

type VarItem = { label: string; value: string }

type Props = {
  onAddVariable: (variable: string) => void
  variables?: VarItem[]
}

/** Mesmo token esperado em `strings.replaceVariables` no back. */
const TOKEN_NOME_PARTICIPANTE = '{Nome do participante}'

export function MessageVariableChips({ onAddVariable, variables = [] }: Props) {
  const merged: VarItem[] = variables.filter(
    (v) => v?.value && !['nome', 'telefone'].includes(v.value)
  )

  return (
    <div className={styles.chipsRow} role="group" aria-label="Variáveis da mensagem">
      <button
        type="button"
        className={`${styles.chip} ${styles['chip--nome']}`}
        onClick={() => onAddVariable(TOKEN_NOME_PARTICIPANTE)}
      >
        <span className={styles.chipPlus} aria-hidden>
          +
        </span>
        Nome
      </button>
      {merged.map((v) => {
        const token = `\${${v.value}}`
        return (
          <button
            key={v.value}
            type="button"
            className={`${styles.chip} ${styles['chip--extra']}`}
            onClick={() => onAddVariable(token)}
          >
            <span className={styles.chipPlus} aria-hidden>
              +
            </span>
            {v.label}
          </button>
        )
      })}
    </div>
  )
}
